<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less">
body {
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("./assets/backgroundimg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  /* background-color: #021936; */
  font-family: "PingFangSC-Semibold", "PingFangSC";

  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  }
  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-image: url("./assets/scrollthumb.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
    background-color: #3289ff;
  }
  ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 8px;
    background-image: url("./assets/scrolltrack.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}
.trends {
  font-family: "TRENDS";
}
.arialblack {
  font-family: "ArialBlack";
}
.color_red {
  color: #ef2605;
}
.color_orange {
  color: #fe685a;
}
.color_blue {
  color: #81f3f3;
}
.color_blue2 {
  color: #319ce2;
}
.color_blue3 {
  color: #048ffe;
}
.color_green {
  color: #8cee74;
}
.color_green2 {
  color: #44cb96;
}
.color_green3 {
  color: #11eade;
}
.color_green4 {
  color: #2bddcf;
}
//下拉框统一样式
.el-dropdown-menu {
  box-shadow: 0px 2px 6px 2px rgba(0, 255, 234, 1);
  border: none;
  background-color: #02112a;
  border-radius: 8px;
  .el-dropdown-menu__item {
    text-align: center;
    font-size: 20px;
    color: #dfeef3;
    border-bottom: 0.1px solid #1fb5da;
  }
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
    background-color: #02112a;
    color: #1fb5da;
  }
  .el-dropdown-menu__item:nth-last-child(2) {
    border-bottom: 0;
  }
  .el-dropdown-menu__item:hover {
    background-color: #02112a;
    color: #1fb5da;
  }
  .textcolor {
    color: #1fb5da;
  }
  .textcolor2 {
    color: #dfeef3;
  }
}
.el-button {
  border: none;
}
.button {
  border: 0 !important;
  padding: 0;
  margin: 0;
}
//全景视图图标
.panorama {
  position: absolute;
  background-image: url("./assets/quanjing.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 138px;
  height: 138px;
  text-align: center;
  padding: 27px 43px;
  font-size: 24px;
  font-weight: bold;
  line-height: 32px;
  color: #fff;
  z-index: 1999;
  cursor: pointer;
}
//清除浏览器滚动条样式
html {
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  overflow: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
}
html::-webkit-scrollbar {
  width: 0 !important;
}
.tab_title {
  background-image: url("./assets/titlebkg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 32px;
  line-height: 32px;
  width: 273px;
  padding-left: 4px;
  color: #83d6fe;
  font-size: 20px;
}
//背景透明
.bkglucency {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 5px;
}
//弹窗样式
.el-popover {
  background: #89c5fd !important;
  border-color: #89c5fd !important;
  color: #000 !important;
  font-size: 24px !important;
  // width: 558px !important;
}
.el-popover[x-placement^="bottom"] .popper__arrow,
.el-popover[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #89c5fd !important;
}
.el-popper[x-placement^="top"] .popper__arrow,
.el-popper[x-placement^="top"] .popper__arrow::after {
  border-top-color: #89c5fd !important;
}
//日期格式调整
.times {
  position: relative;
  .el-input {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    input {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      color: rgba(0, 0, 0, 0) !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue